import { render, staticRenderFns } from "./scoreTip.vue?vue&type=template&id=64717e99&scoped=true"
import script from "./scoreTip.vue?vue&type=script&lang=js"
export * from "./scoreTip.vue?vue&type=script&lang=js"
import style0 from "./scoreTip.vue?vue&type=style&index=0&id=64717e99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64717e99",
  null
  
)

export default component.exports